import Image from '../../../Image';

//futbol
import FieldUnavailableFutbol from '../../images/sports/futbol/icons/field-unavailable.svg';
import FieldAvailableFutbol from '../../images/sports/futbol/icons/field-available.svg';
import FieldSelectedFutbol from '../../images/sports/futbol/icons/field-selected.svg';
//padel
import FieldUnavailablePadel from '../../images/sports/padel/icons/field-unavailable.svg';
import FieldAvailablePadel from '../../images/sports/padel/icons/field-available.svg';
import FieldSelectedPadel from '../../images/sports/padel/icons/field-selected.svg';
//tenis
import FieldUnavailableTenis from '../../images/sports/tenis/icons/field-unavailable.svg';
import FieldAvailableTenis from '../../images/sports/tenis/icons/field-available.svg';
import FieldSelectedTenis from '../../images/sports/tenis/icons/field-selected.svg';
//basquetbol
import FieldUnavailableBasquetbol from '../../images/sports/basquetbol/icons/field-unavailable.svg';
import FieldAvailableBasquetbol from '../../images/sports/basquetbol/icons/field-available.svg';
import FieldSelectedBasquetbol from '../../images/sports/basquetbol/icons/field-selected.svg';
import { FieldProps } from '../../../interfaces';
// Component Commons

export default function Field({ field, handleSelectedField, selectedField, sport }: FieldProps): JSX.Element {
    const { id, name, price, available } = field;
    const handleClick = () => {
        handleSelectedField(id);
    };

    const fieldImg = {
        futbol: {
            unAvailable: FieldUnavailableFutbol,
            available: FieldAvailableFutbol,
            selected: FieldSelectedFutbol,
        },
        padel: {
            unAvailable: FieldUnavailablePadel,
            available: FieldAvailablePadel,
            selected: FieldSelectedPadel,
        },
        tenis: {
            unAvailable: FieldUnavailableTenis,
            available: FieldAvailableTenis,
            selected: FieldSelectedTenis,
        },
        basquetbol: {
            unAvailable: FieldUnavailableBasquetbol,
            available: FieldAvailableBasquetbol,
            selected: FieldSelectedBasquetbol,
        },
    };

    const getField = () => {
        //console.log(fieldImg[sport], '*fields*', sport, fieldImg);
        if (sport && fieldImg && fieldImg[sport]) {
            return selectedField == field.id && available
                ? fieldImg[sport].selected
                : available
                ? fieldImg[sport].available
                : fieldImg[sport].unAvailable;
        }
        return null;
    };

    return (
        <button
            type="button"
            disabled={!available}
            className="text-center text-sm-light-gray space-x-1 snap-center"
            onClick={() => handleClick()}
        >
            <div className="p-0 m-0">
                <div className="flex justify-center items-center">
                    {!available && (
                        <div className="absolute">
                            {' '}
                            <p className={`text-gray-600 flex-col pt-14 text-xs'`}>No disponible</p>{' '}
                        </div>
                    )}
                    <Image src={getField()} alt={`${name}`} height={120} width={120} />
                </div>
                <div className="flex justify-center items-center ">
                    <div className="w-36 mt-2">
                        <p>{name}</p>

                        <p>{parseInt(price).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</p>
                    </div>
                </div>
            </div>
        </button>
    );
}
